import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";

export default function DisneyActivation({onContinue}) {
  const {token} = useParams();
  const [tokenInfo, setTokenInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") || Object.assign(document.createElement('link'), {rel: 'icon'});
    const prevIcon = link.href;
    const prevTitle = document.title;
    link.href = '/disney/favicon.ico';
    document.head.appendChild(link);
    document.title = 'Activa tu cuenta de Disney+';
    return () => {
      link.href = prevIcon;
      document.title = prevTitle;
    };
  }, []);

  useEffect(() => {
    if (token) fetchTokenInfo();
  }, [token]);

  const fetchTokenInfo = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/v1/activate/${token}`);
      if (!res.ok) throw new Error(`Error ${res.status}`);
      const data = await res.json();
      setTokenInfo(data);
    } catch (err) {
      setError('No fué posible encontrar el token. Por favor, verifica que el link sea correcto y que no haya caducado.');
    } finally {
      setLoading(false);
    }
  };

  const handleContinue = onContinue || (async () => {
    const res = await fetch(`/api/v1/activate/${token}/click`);
    window.location.href = tokenInfo?.activationUrl;
  });

  if (loading) {
    return (
      <div className="h-screen w-full flex flex-col items-center justify-center gap-4 bg-[#0e1a3d]">
        <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-white animate-spin"/>
        <p className="text-white text-lg font-medium">Cargando...</p>
      </div>
    );
  }

  return (
    <>
      {/* ── DESKTOP ── */}
      <div
        className="hidden md:flex h-screen w-full overflow-hidden"
        style={{
          backgroundImage: 'url(/disney/fondo.jpg.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Columna izquierda — área teal */}
        {tokenInfo?.status !== 'used' ?
          <div className="w-[62%] flex flex-col items-center justify-start py-0 px-[3vw]">
            <div className="flex flex-col gap-[1vh] mt-[10vh] text-center font-bold text-white text-2xl">
              {tokenInfo?.status === 'blocked-country'
                ? 'Esta promoción solo está disponible para usuarios ubicados en Colombia.'
                : 'El token ha expirado. Por favor, solicita uno nuevo.'}
            </div>
          </div> :
          <div className="w-[62%] flex flex-col items-center justify-start py-0 px-[3vw]">
            <img
              src="/disney/titulo.png"
              alt="Activa tu cuenta Disney+ en pasos simples"
            />

            <div className="flex flex-col gap-[1vh]">
              <img
                src="/disney/1.png"
                alt="Antes de abrir el link, Cierra sesión en Disney+ (en navegador y app del dispositivo en el que usarás el token). Si abres el link con una sesión iniciada en Disney+, la membresía se aplica de inmediato"
                style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}}
              />
              <img
                src="/disney/2.png"
                alt="Antes de abrir el link, Cierra sesión en Disney+ (en navegador y app del dispositivo en el que usarás el token). Si abres el link con una sesión iniciada en Disney+, la membresía se aplica de inmediato"
                style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}}
              />
              <img
                src="/disney/3.png"
                alt="Antes de abrir el link, Cierra sesión en Disney+ (en navegador y app del dispositivo en el que usarás el token). Si abres el link con una sesión iniciada en Disney+, la membresía se aplica de inmediato"
                style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}}
              />
              <img
                src="/disney/4.png"
                alt="Antes de abrir el link, Cierra sesión en Disney+ (en navegador y app del dispositivo en el que usarás el token). Si abres el link con una sesión iniciada en Disney+, la membresía se aplica de inmediato"
                style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}}
              />
            </div>

            <img
              src="/disney/5.png"
              alt="Si ya tienes suscripción activa: espera que termine"
              style={{maxHeight: '13vh', width: 'auto', maxWidth: '90%'}}
            />
          </div>
        }

        {/* Columna derecha — franja blanca */}
        <div className="w-[38%] flex flex-col items-center justify-between py-[3vh] pr-[2vw]">

          <img
            src="/disney/cel.png"
            alt="Disney+ en tu celular"
            style={{maxHeight: '82vh', width: 'auto'}}
          />

          {tokenInfo?.activationUrl &&
            <button
              onClick={handleContinue}
              className="cursor-pointer hover:opacity-90 active:scale-95 transition-all self-end"
              aria-label="Continuar a usar el token"
            >
              <img
                src="/disney/boton.png"
                alt="Continuar a usar el token"
                style={{maxHeight: '8vh', width: 'auto'}}
              />
            </button>
          }
          {tokenInfo?.status === 'used' && tokenInfo?.nuplinState === 'COMPLETED' && <div>
            <div className="font-bold text-black text-2xl">
              Este token ya fue activado el {new Date(tokenInfo.activationDate).toLocaleDateString('es-ES', {})}
            </div>
          </div>}
        </div>
      </div>

      {/* ── MÓVIL ── */}
      <div
        className="md:hidden min-h-screen flex flex-col items-center px-4 py-6 gap-4"
        style={{
          backgroundImage: 'url(/disney/fondo-vertical.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <img
          src="/disney/titulo-vertical.png"
          alt="Activa tu cuenta Disney+ en pasos simples"
          className="w-full max-w-sm"
        />

        <img
          src="/disney/textos+.png"
          alt="Pasos de activación"
          className="w-full"
        />

        <img
          src="/disney/5.png"
          alt="Si ya tienes suscripción activa: espera que termine"
          className="w-full"
        />

        {tokenInfo?.activationUrl &&
          <button
            onClick={handleContinue}
            className="cursor-pointer hover:opacity-90 active:scale-95 transition-all"
            aria-label="Continuar a usar el token"
          >
            <img
              src="/disney/boton.png"
              alt="Continuar a usar el token"
              className="w-52"
            />
          </button>
        }
        {tokenInfo?.status === 'used' && tokenInfo?.nuplinState === 'COMPLETED' && <div>
          <div className="flex flex-col gap-[1vh] text-center font-bold text-white text-2xl">
            Este token ya fue activado el {new Date(tokenInfo.activationDate).toLocaleDateString('es-ES', {})}
          </div>
        </div>}
      </div>
    </>
  );
}